import React, { useState } from "react";
import "./styles.css";
import MultiSelect from "react-multi-select-component";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { display } from "@mui/system";
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';




const SelectAll = (props) => {
  function customTheme(theme) {
    return {
      ...theme,
      colors: {
        ...theme.colors,
        primary25: "red",
        primary: "red"
      }
    };
  }
  const valueRenderer = (selected) => {
  
      return <div style={{display:'flex'}}><FilterAltOutlinedIcon style={{color:'#0D5C75'}}/> &nbsp; <div style={{color:'#888888',fontSize:'15px',marginTop:'3px'}}>Filter By Job Status</div></div>
    

   
  };
  

  const [selected, setSelected] = useState([]);
  return (
    <div>
      <MultiSelect
        options={props?.options}
        // theme={customTheme}
        selected={selected}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
          ...theme.colors,
            text: 'orangered',
            primary25: 'hotpink',
            primary: 'black',
          },
        })}
        disableSearch={true}
        onChange={setSelected}
        valueRenderer={valueRenderer}
        selectAll= {"Select All"}
        // labelledBy={<span> <FilterAltOutlinedIcon/>Select</span>}
        // labelledBy={"hello"}
      />
    </div>
  );
};


export default SelectAll;